import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: {
    page: 1,
    totalPage: 2
  },
  condition: {
    searchText:'',
    page:1,
    limit:10,
    startDate:'',
    endDate:'',
    regDate:'',
    storeNo:null,
    userNo:null
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
